<script lang="ts">
  import { exerciseIDsStore } from "../stores/exerciseIDsStore"
  import { exerciseDatasStore } from "../stores/exerciseDatasStore"
  import { userExerciseIDStore} from "../stores/userExerciseIDStore"
	import { ExerciseData } from "../dataTypes/exerciseData"
  import { userExerciseDataStore, createUserExerciseData } from "../stores/userExerciseDataStore"
  import type { UserExerciseData } from "../stores/userExerciseDataStore"
  import {appName} from "../appName"

  import Loading from "./Loading.svelte"
  import ConceptQuiz from "./ConceptQuiz.svelte"
  import StepCodeCanvas from "./StepCodeCanvas.svelte"
  import TextBlurb from "./TextBlurb.svelte"
  import TestExercise from "./TestExercise.svelte"
  import FactoryMultipleChoiceQuiz from "./FactoryMultipleChoiceQuiz.svelte"
  import FactorySingleChoiceQuiz from "./FactorySingleChoiceQuiz.svelte"
  import Dialog from "./Dialog.svelte"
  import SuccessDialogContent from "./SuccessDialogContent.svelte"
  import EndDialogContent from "./EndDialogContent.svelte"
  //import AboutDialog from "./AboutDialog.svelte"
  import TableOfContents from "./TableOfContents.svelte"

  import { fade } from 'svelte/transition';
  import { metric } from "../api/metric";

  let currentExerciseID:string
  let currentExerciseData:ExerciseData
  let currentExerciseConstructor:Function
  let succeeded:boolean = false;
  let hasPrevious:boolean
  let showSuccessDialog:boolean = false
  let showEndDialog:boolean = false
  let showAbout:boolean = false
  $: hasNext = $userExerciseDataStore[currentExerciseID] && $userExerciseDataStore[currentExerciseID].completed
  $: {
    switch(currentExerciseData.type) {
      case "ConceptQuiz": {
        currentExerciseConstructor = ConceptQuiz
        break
      }
      case "FactoryMultipleChoiceQuiz": {
        currentExerciseConstructor = FactoryMultipleChoiceQuiz
        break
      }
      case "FactorySingleChoiceQuiz" : {
        currentExerciseConstructor = FactorySingleChoiceQuiz
        break
      }
      case "StepCodeCanvas": {
        currentExerciseConstructor = StepCodeCanvas
        break;
      }
      case "TestExercise": {
        currentExerciseConstructor = TestExercise
        break
      }
      case "TextBlurb": {
        currentExerciseConstructor = TextBlurb
        break;
      }
      default: {
        currentExerciseConstructor = Loading
        break
      }
    }
    refresh()
  }

  refresh()

  function refresh():void {
    if (currentExerciseID != $userExerciseIDStore) {
      if (currentExerciseID) {
        metric("level_end", {"level_name":currentExerciseID, "success":succeeded})
        succeeded = false
      }
      metric("level_start", {"level_name":$userExerciseIDStore})
    }

    //currentExerciseData
    try {
      currentExerciseData = $exerciseDatasStore.get($userExerciseIDStore)
      currentExerciseID = $userExerciseIDStore
    }
    catch(error:any) {
      $userExerciseIDStore = getLastUserCompletedID()
      currentExerciseData = $exerciseDatasStore.get($userExerciseIDStore)
      currentExerciseID = $userExerciseIDStore
    }
    hasPrevious = currentExerciseID != $exerciseIDsStore[0]

    ensureUserExerciseData(currentExerciseID)
  }

  function getLastUserCompletedID():string {
    let validID:string = $exerciseIDsStore[0]
    let testID:string = ""
    for (testID of $exerciseIDsStore) {
      if (!($userExerciseDataStore[testID] && $userExerciseDataStore[testID].completed)) {
        break
      }
      validID = testID
    }
    return validID
  }

  function handleExerciseCompleted():void {
    succeeded = true

    $userExerciseDataStore[currentExerciseID].completed = true
    showSuccessDialog = true
  }

  function handleExerciseNext():void {
    succeeded = true

    $userExerciseDataStore[currentExerciseID].completed = true
    handleNext();
  }

  function handleSave(customEvent:CustomEvent<UserExerciseData>):void {
    $userExerciseDataStore[currentExerciseID] = customEvent.detail
  }

  function ensureUserExerciseData(exerciseID:string):void {
    if ($userExerciseDataStore[exerciseID] == undefined) {
      $userExerciseDataStore[exerciseID] = createUserExerciseData(exerciseID)
    }
  }

	function handlePrevious():void {
    if (hasPrevious) {
      const exerciseIndex = $exerciseIDsStore.findIndex((exerciseID) => exerciseID === currentExerciseID)
      $userExerciseIDStore = $exerciseIDsStore[exerciseIndex - 1]
      refresh()
    }
	}

  function handleNext():void {
      const exerciseIndex = $exerciseIDsStore.findIndex((exerciseID) => exerciseID === currentExerciseID)
      if (exerciseIndex < $exerciseIDsStore.length - 1) {
        //Prepare for next exercise we are entering
        $userExerciseIDStore = $exerciseIDsStore[exerciseIndex + 1]
        refresh()
      }
      else {
        showEndDialog = true
      }
  }

  function handleHamburger():void {
    showAbout = true
  }

  function selectExercise(exerciseID:string):boolean {
    const exerciseIndex = $exerciseIDsStore.findIndex((testExerciseID) => testExerciseID === exerciseID)
    if (exerciseIndex >= 0 && exerciseIndex < $exerciseIDsStore.length) {
        //Prepare for next exercise we are entering
        $userExerciseIDStore = $exerciseIDsStore[exerciseIndex]
        refresh()
        return true
    }
    return false
  }
</script>

<div class="v-screen h-screen flex flex-col bg-darkBack">
  <header class="grid grid-cols-3 px-3 py-2 bg-darkBackHigh">
    <div class="text-darkForeHigh text-left">{currentExerciseData.name}</div>
    <div class="text-darkForeHigh text-center">{appName}</div>
    <div class="text-darkForeHigh text-right"><button on:click={handleHamburger}>☰</button></div>
  </header>
  {#key currentExerciseConstructor}
    <svelte:component on:completed={handleExerciseCompleted} on:next={handleExerciseNext} on:save={handleSave} this={currentExerciseConstructor} exerciseData={currentExerciseData} userExerciseData={$userExerciseDataStore[currentExerciseID]}/>
  {/key}
  <footer>
    {#if hasPrevious}
      <button on:click={handlePrevious} class="float-left btn-darkBack">Previous</button>
    {/if}
    {#if hasNext}
      <button on:click={handleNext} transition:fade class="float-right btn-darkBackHigh text-orange">Next</button>
    {/if}
  </footer>
  <Dialog show={showSuccessDialog}>
    <SuccessDialogContent 
      on:stay={()=>{showSuccessDialog = false}} 
      on:next={ ()=>{showSuccessDialog = false; handleNext()}}/>
  </Dialog>
  <Dialog show={showEndDialog}>
    <EndDialogContent on:accept={()=>{showEndDialog = false}}/>
  </Dialog>
  <Dialog class="h-4/5" show={showAbout}>
    <TableOfContents selectedExerciseID="{currentExerciseID}" on:accept={(event)=>{showAbout = false; selectExercise(event.detail);}} on:cancel={()=>{showAbout = false}}/>
  </Dialog>
  <!--<Dialog show={showAbout}>
    <AboutDialog on:accept={()=>{showAbout = false}}/>
  </Dialog>-->
</div>
